import { useEffect, useState } from 'react'
import { CloseIcon } from '../../../assets/icons/Svg';
import Label from '../../ui/Label';
import Input from '../../ui/Input';
import { showToast } from '../../../toastify/Toast';
import { NewChapelForm } from '../../../types/chapel';
import { useDispatch, useSelector } from 'react-redux';
import { clearSelectedChapel, selectCurrentChapel } from '../../../features/chapel/chapelSlice';
import { clearTypeModal, clearTypeOfShowModalType, selectCurrentModalType } from '../../../features/modal/modalSlice';
import { addPackageToChapel } from '../../../features/package/packageSlice';
import { handleApiError } from '../../../utils/handleApiError';
import { chapelStatus } from '../../../data/admin-data';
import { TypesStatusListFilter } from '../../../data/data-products';
import { selectCurrentUserRole } from '../../../features/auth/authSlice';
import { useMutationData } from '../../../hooks/api/useMutationData';

export default function ChapelModal() {
    
    const dispatch = useDispatch();
    const { newChapel: createNewChapel, isLoadingNewChapel, isErrorNewChapel, updateChapel, isLoadingUpdateChapel, isErrorUpdateChapel } = useMutationData()
    const selectedChapel = useSelector(selectCurrentChapel);
    const typeModal = useSelector(selectCurrentModalType);
    const [isUpdateChapel, setIsUpdateChapel] = useState<boolean>(false)
    const isLoading = isLoadingNewChapel || isLoadingUpdateChapel;
    const userRole = useSelector(selectCurrentUserRole)

    useEffect(() => {
        if (isErrorNewChapel) {
            showToast("Failed to create chapel. Please try again.", "error");
        }
        if (isErrorUpdateChapel) {
            showToast("Failed to update chapel. Please try again.", "error");
        }
    }, [isErrorNewChapel, isErrorUpdateChapel]);


    // const StatusOptions = [ "Active", "Inactive" ]
    // const [selectedLabelStatus, setSelectedLabelStatus] = useState<string>(StatusOptions[0])
    // const [isEditPackageSetUp, setIsEditPackageSetUp] = useState<boolean>(false)

    const [chapelForm, setChapelForm] = useState<NewChapelForm>({
        chapelName: '',
        description: '',
        status: 'Active',
    })

    useEffect(() => {
        if (typeModal === 'updateChapel' && selectedChapel) {
            setChapelForm({
                chapelName: selectedChapel.chapelName || '',
                description: selectedChapel.description || '',
                status: selectedChapel.status || '' 
            });
            dispatch(
                addPackageToChapel({
                    packageID: Number(selectedChapel?.packageID),
                    packageName: selectedChapel?.package?.packageName ?? '',
                    quantity: Number(selectedChapel?.package?.quantity),
                    totalValue: Number(selectedChapel?.package?.totalValue),
                    description: selectedChapel?.description,
                })
            );

        }  else if (typeModal === 'newChapel') {
            setChapelForm({
                chapelName: '',
                description: '',
                status: ''
            });
        }
    }, [selectedChapel, typeModal, dispatch]);

    const [isSubmitDisabled, setIsSubmitDisabled] = useState<boolean>(true);
    const resolvedStatus = typeModal === 'updateChapel' ? chapelStatus.find((status) => status.id === Number(selectedChapel?.status)) ?? chapelStatus[0] : chapelStatus[0];
    const [isOpenDropdownStatus, setIsOpenDropdownStatus] = useState<boolean>(false)
    const [selectedLabelStatus, setSelectedLabelStatus] = useState<TypesStatusListFilter>(resolvedStatus)

    useEffect(() => {
        const { chapelName } = chapelForm;

        const allFilled  =
            chapelName.trim() !== ''

        setIsSubmitDisabled(!allFilled );
    }, [chapelForm])

    const handleSaveNewChapel = async (chapelId: number) => {
        // if (!chapelForm.chapelName) {
        //     showToast("Please fill in all required fields.", "error");
        //     return;
        // }
        const newChapelForm = {
            chapelName: chapelForm.chapelName,
            description: chapelForm.description,
            // packageID: selectedAddPackageToChapel?.packageID,
            // statusId: selectedLabelStatus.id
        }

        try {
            if (typeModal === "newChapel") {
                await createNewChapel(newChapelForm).unwrap();
                showToast("New chapel has been added successfully.", "success");
            } else if (typeModal === "updateChapel" ) {

                if (!chapelId) {
                    showToast("Something went wrong. Missing chapel ID.", "error");
                    return;
                }
                
                await updateChapel({
                    chapelId,
                    data: newChapelForm,
                }).unwrap();
                showToast("Chapel has been updated successfully.", "success");
            }
            setChapelForm({
                chapelName: '',
                description: '',
                status: ''
            })
        } catch (error) {
            handleApiError(error, "Something went wrong. Please try again.");
        } finally {
            dispatch(clearTypeModal());
            dispatch(clearTypeOfShowModalType());
            dispatch(clearSelectedChapel());
            // dispatch(removePackageFromChapel());
        }
    };

    const handleCloseChapelModal = () => {
        dispatch(clearTypeModal());
        dispatch(clearSelectedChapel());
        dispatch(clearTypeOfShowModalType());
        // dispatch(removePackageFromChapel());
    }

    const isDisableInput = isUpdateChapel === false && typeModal === "updateChapel"
    const isDisabledStatusChapel = (isUpdateChapel === false && typeModal === "updateChapel") || !['Super Admin', 'Data Admin'].includes(userRole ?? '');

    const resetFormToSelectedChapel = () => {
        if (selectedChapel) {
            setChapelForm({
            chapelName: selectedChapel.chapelName || '',
            description: selectedChapel.description || '',
            status: selectedChapel.status || '',
            });
        }
    };


    return (
        <div className='fixed m-0 p-0 inset-0 bg-black bg-opacity-30 backdrop-blur-sm flex justify-center items-center z-[100]'>
            <div className='relative w-[90%] mx-5 bg-white rounded-lg shadow px-5 flex md:w-[75%] lg:max-w-[45%] lg:mx-auto'>
                <div className='flex flex-col w-full'>
                    <div className='py-5'>
                        <div className="flex justify-between items-center py-1">
                            <div className="items-start">
                                <p className="text-base items-start font-semibold leading-tight text-slate-900">
                                    {typeModal === 'newChapel' && 'New Chapel'}
                                    {/* {typeModal === 'updateChapel' && 'Update Chapel'} */}
                                    {typeModal === 'updateChapel' && 'Chapel Information'}
                                </p>
                            </div>
                            <div className="flex justify-end items-center">
                                <button
                                    type="button"
                                    className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center"
                                    onClick={handleCloseChapelModal}
                                >
                                    <CloseIcon/>
                                </button>
                            </div>
                        </div>
                        <hr className="h-px bg-gray-200 border-0" />
                        <div className='py-2 space-y-3'>
                            <div className='grid grid-cols-1 gap-3'>
                                <div className=''>
                                    <Label label={'Chapel Name *'}/>
                                    <Input
                                        type={'text'}
                                        value={chapelForm.chapelName}
                                        onChange={(e) => 
                                            setChapelForm({ ...chapelForm, chapelName: e.target.value })
                                        }
                                        placeholder={'Enter Chapel Name'}
                                        required
                                        disabled={isDisableInput || isLoading || isUpdateChapel === false}
                                    />
                                </div>
                                <div className=''>
                                    <Label label={'Chapel Description'} subLabel='(optional)'/>
                                    <Input
                                        type={'text'}
                                        value={chapelForm.description}
                                        onChange={(e) => 
                                            setChapelForm({ ...chapelForm, description: e.target.value })
                                        }
                                        placeholder={'Enter description'}
                                        required
                                        // disabled={isUpdateChapel === false}
                                        disabled={isDisableInput || isLoading}
                                    />
                                </div>
                                {/* <div className=''>
                                    <Label label={'Status *'}/>
                                    <div className='relative inline-block h-auto w-full'>
                                        <div className='w-full h-auto'>
                                            <DropdownBtn
                                                label={selectedLabelStatus.label}
                                                isOpen={isOpenDropdownStatus}
                                                setIsOpenStatus={setIsOpenDropdownStatus}
                                                isCustomClass={true}
                                                disabled={isDisabledStatusChapel}
                                                customClass={`flex w-full justify-between items-center font-medium rounded transition px-4  text-black py-2 space-x-2 text-sm  border border-gray-300 outline-none placeholder:text-gray-400 focus:border-black ${isUpdateChapel === false && typeModal === "updateChapel" || isDisabledStatusChapel ? 'bg-gray-100 cursor-not-allowed' : ''}`}
                                            />
                                            {isOpenDropdownStatus && (
                                                <ul className="absolute w-full overflow-hidden mt-1 bg-white border rounded shadow-lg z-10 border-gray-400">
                                                    {chapelStatus.map((opt, i) => (
                                                            <li
                                                                key={opt.id}
                                                                onClick={() => {
                                                                    setSelectedLabelStatus(opt)
                                                                    setIsOpenDropdownStatus(false)
                                                                }}
                                                                className='px-3 py-1.5 md:px-5 md:py-2 hover:bg-gray-100 cursor-pointer text-[12px] md:text-[13px] w-full'
                                                            >
                                                                {opt.label}
                                                            </li>
                                                        ))
                                                    }
                                                </ul>
                                            )}
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                        {/* {isUpdateChapel === false && typeModal === "updateChapel" ? (
                            <button
                                onClick={() => setIsUpdateChapel(true)}
                                className="w-full text-sm px-4 py-2 rounded font-medium bg-cbColor text-white"
                            >
                                Update chapel
                            </button>
                            ) : typeModal === "newChapel" ? (
                                <button
                                    onClick={() => handleSaveNewChapel(0)}
                                    disabled={isSubmitDisabled || isLoading}
                                    className={`w-full text-sm px-4 py-2 rounded font-medium transition-all
                                    ${isSubmitDisabled || isLoading ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}`}
                                >
                                    {isLoadingNewChapel ? (
                                        <Loading setH={'h-[20px]'} message={'Saving...'}/>
                                    ) : ('Save')}
                                </button>
                            ) : (
                                <>
                                    {isLoadingUpdateChapel ? (
                                        <div>
                                            <button
                                                className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-200 border text-black"
                                            >
                                                <Loading setH={'h-[20px]'} message={'Saving...'}/>
                                            </button>
                                        </div>
                                    ) : (
                                        <div className="grid grid-cols-2 gap-2">
                                            <button
                                                onClick={() => {
                                                    resetFormToSelectedChapel()
                                                    setIsUpdateChapel(false)
                                                }}
                                                className="w-full text-sm px-4 py-2 rounded font-medium bg-gray-200 border text-black"
                                            >
                                                Cancel
                                            </button>
                                            <button
                                                onClick={() => handleSaveNewChapel(selectedChapel?.chapelID || 0)}
                                                disabled={isSubmitDisabled || isLoading}
                                                className={`w-full text-sm px-4 py-2 rounded font-medium transition-all
                                                ${isSubmitDisabled || isLoading ? 'cursor-not-allowed bg-gray-200 border text-black' : 'bg-cbColor text-white'}`}
                                            >
                                                Save
                                            </button>
                                        </div>
                                    )}
                                </>
                                
                            )
                        } */}
                    </div>
                </div>
            </div>
        </div>
    )
}
